import styled from 'styled-components'

export const Chiclet = styled.div`
  ${({ color, $shadow = true, theme: { button, colors } }) => `
  margin: 0.125rem 0;
  width: 2.5rem;
  height: 2.5rem;
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
  background: ${colors(color || 'chrome')};
  border: 1px solid ${colors('foreground', 0.2)};
  border-radius: ${button?.main?.radius || '0'};
  &:active {
    background: ${colors('chrome')};
    color: ${colors('text')};
  }
`}
`
